export function VectorGuaranteedPlusIcon({ height = 16 }: { height?: number }) {
  return (
    <svg
      width={height}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="8" cy="8" r="8" fill="url(#paint0_linear_2308_17902)" />
      <path
        d="M5.41211 4.57251C5.80527 4.57251 6.17082 4.62912 6.50781 4.74146C6.84676 4.85162 7.14617 5.00899 7.40527 5.21411C7.66659 5.41715 7.87728 5.65815 8.03711 5.93677C8.19692 6.21538 8.29356 6.52116 8.32812 6.85376H6.50781C6.47973 6.73927 6.43549 6.63841 6.375 6.552C6.31454 6.46349 6.23814 6.3898 6.14746 6.32935C6.05897 6.26675 5.9556 6.21994 5.83691 6.1897C5.7203 6.15731 5.59153 6.14088 5.45117 6.14087C5.14888 6.14087 4.89056 6.21307 4.67676 6.35767C4.46506 6.5024 4.30276 6.71146 4.19043 6.98364C4.08036 7.25567 4.02544 7.58381 4.02539 7.96802C4.02539 8.3566 4.07789 8.68967 4.18359 8.96606C4.28944 9.24257 4.44769 9.45491 4.65723 9.60181C4.86674 9.74864 5.12747 9.82153 5.43848 9.82153C5.71264 9.82149 5.9407 9.78228 6.12207 9.70239C6.30562 9.62247 6.4425 9.50843 6.5332 9.36157C6.61883 9.22287 6.66223 9.06113 6.66699 8.87622H5.46387V7.59302H8.40625V8.51294C8.40624 9.11769 8.27749 9.63486 8.02051 10.0647C7.7656 10.4924 7.41319 10.8211 6.96387 11.05C6.51678 11.2768 6.00361 11.3899 5.4248 11.3899C4.77902 11.3899 4.21177 11.2531 3.72363 10.9788C3.23557 10.7044 2.85438 10.3134 2.58008 9.80591C2.30789 9.29826 2.17188 8.69429 2.17188 7.99438C2.17188 7.44581 2.25463 6.95971 2.4209 6.53638C2.58935 6.1131 2.82311 5.75569 3.12109 5.46411C3.4192 5.17032 3.76427 4.94813 4.15527 4.79907C4.54613 4.64798 4.96513 4.57251 5.41211 4.57251ZM11.5234 5.59204C11.9019 5.59225 12.2088 5.89916 12.209 6.27759V7.30591H13.2373C13.6159 7.30591 13.9226 7.61388 13.9229 7.99243C13.9227 8.3236 13.6883 8.60032 13.376 8.66431L13.2373 8.67798H12.209V9.7063C12.209 10.0849 11.902 10.3916 11.5234 10.3918C11.1449 10.3916 10.8369 10.0849 10.8369 9.7063V8.67798H9.80859C9.43015 8.67778 9.12326 8.37088 9.12305 7.99243C9.12327 7.614 9.43016 7.30611 9.80859 7.30591H10.8369V6.27759C10.8371 5.89916 11.145 5.59224 11.5234 5.59204Z"
        fill="black"
      />
      <defs>
        <linearGradient
          id="paint0_linear_2308_17902"
          x1="0.923077"
          y1="-10.6667"
          x2="3.20537"
          y2="27.9087"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A3652A" />
          <stop offset="0.21" stopColor="#FFBD77" />
          <stop offset="0.38" stopColor="#FFE188" />
          <stop offset="0.53" stopColor="#FFB654" />
          <stop offset="0.695" stopColor="#E17C00" />
          <stop offset="0.84" stopColor="#D86C00" />
          <stop offset="1" stopColor="#733D19" />
        </linearGradient>
      </defs>
    </svg>
  );
}
